import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M375,585.675 L468.5,585.675 L468.5,185 L375,185 L375,585.675 Z M640.225,532.675 L1920.225,532.675 L1920.225,307.675 L640.225,307.675 L640.225,532.675 Z M375.275,1184.675 L468.775,1184.675 L468.775,784 L375.275,784 L375.275,1184.675 Z M190.225,1184.675 L283.725,1184.675 L283.725,784 L190.225,784 L190.225,1184.675 Z M640.225,1097.676 L1920.225,1097.676 L1920.225,872.675 L640.225,872.675 L640.225,1097.676 Z M375.225,1734.675 L468.724,1734.675 L468.724,1333.999 L375.225,1333.999 L375.225,1734.675 Z M191.225,1734.675 L284.725,1734.675 L284.725,1333.999 L191.225,1333.999 L191.225,1734.675 Z M8,1734.675 L101.5,1734.675 L101.5,1333.999 L8,1333.999 L8,1734.675 Z M640.225,1660.675 L1920.225,1660.675 L1920.225,1435.675 L640.225,1435.675 L640.225,1660.675 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconBulletListRomanSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconBulletListRomanSolid, _Component);

  var _super = _createSuper(IconBulletListRomanSolid);

  function IconBulletListRomanSolid() {
    _classCallCheck(this, IconBulletListRomanSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconBulletListRomanSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconBulletListRoman",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconBulletListRomanSolid.displayName = "IconBulletListRomanSolid";
  return IconBulletListRomanSolid;
}(Component);

IconBulletListRomanSolid.glyphName = 'bullet-list-roman';
IconBulletListRomanSolid.variant = 'Solid';
IconBulletListRomanSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconBulletListRomanSolid;
export { IconBulletListRomanSolid };